import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import DataTable from '../../../../../shared/components/Table';
import { GridColDef } from '@mui/x-data-grid';
import { Button } from '../../../../../shared/components/button/Button';
import { StatusActions } from './StatusActions';
import { formatCurrency } from '../../../../../shared/utils/helpers/numbers';

const COLUMNS: GridColDef[] = [
  {
    field: 'prod_id',
    headerName: 'Código',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    valueGetter: (value: any) => value,
  },
  {
    field: 'prod_descricao',
    headerName: 'Produto',
    headerAlign: 'left',
    align: 'left',
    width: 300,
    valueGetter: (value: any) => value,
  },
  {
    field: 'value',
    headerName: 'Valor',
    headerAlign: 'left',
    align: 'left',
    width: 150,
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
  {
    field: 'quantidade',
    headerName: 'Qtd',
    headerAlign: 'left',
    align: 'left',
    width: 50,
    valueGetter: (value: any) => value,
  },
  {
    field: 'total',
    headerName: 'Total',
    headerAlign: 'left',
    align: 'left',
    width: 200,
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
  {
    field: 'estoque',
    headerName: 'Saldo em Estoque',
    headerAlign: 'left',
    align: 'left',
    width: 150,
    valueGetter: (value: any) => value,
  },
  {
    field: 'grupo_tributario',
    headerName: 'Grupo Tributário',
    headerAlign: 'left',
    align: 'left',
    width: 150,
    valueGetter: (value: any) => value,
  },
  {
    field: 'prod_armazem',
    headerName: 'Armazem',
    headerAlign: 'left',
    align: 'left',
    valueGetter: (value: any) => value,
  },
  {
    field: 'lote',
    headerName: 'Lote',
    headerAlign: 'left',
    align: 'left',
    valueGetter: (value: any) => value,
  },
  {
    field: 'desconto',
    headerName: 'Desconto Item',
    headerAlign: 'left',
    align: 'left',
    width: 150,
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
  {
    field: 'desconto_rateado',
    headerName: 'Desconto Rateado',
    headerAlign: 'left',
    align: 'left',
    width: 160,
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
  {
    field: 'seguro',
    headerName: 'Seguro',
    headerAlign: 'left',
    align: 'left',
    valueGetter: (value: any) => value,
  },
  {
    field: 'despesa',
    headerName: 'Despesa',
    headerAlign: 'left',
    align: 'left',
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
];

interface TabProdutoProps {
  values: any;
  duploClick?: boolean;
  handleOpenModalSearchProduct: () => void;
  handleDeleteProduct: (product: any) => void;
  handleEditProduct: (product: any) => void;
}

export const TabProduto = ({
  values,
  duploClick,
  handleOpenModalSearchProduct,
  handleDeleteProduct,
  handleEditProduct,
}: TabProdutoProps) => {

  const hiddenFields = ['prod_armazem', 'lote', 'seguro', 'despesa'];

  const visibleColumns = COLUMNS.filter(col => !hiddenFields.includes(col.field));

  const actionColumn: GridColDef = {
    field: 'status',
    headerName: '',
    width: 5,
    renderCell: (params) => (
      <StatusActions params={params} handleDelete={handleDeleteProduct} handleEdit={handleEditProduct} disabled={duploClick} />
    ),
  };

  return (
    <TabPanel value={'2'}>
      <Box className={'flex flex-row space-x-4 pb-4'}>
        <Button
          title={'Adicionar Item'}
          variant={'primary'}
          onClick={() => handleOpenModalSearchProduct()}
          disabled={duploClick}
        />
      </Box>
      <div className={'grid grid-cols-8 gap-7'}>
        <Box className='col-span-8'>
          <DataTable
            height={'48vh'}
            columns={[...visibleColumns, ...[actionColumn]]}
            rows={values?.products_list?.map((item: any, index: number) => {
              return {
                ...item,
                id: index,
              };
            })}
            showFilter={false}
            showButtonToXlsx={false}
          />
        </Box>
      </div>
    </TabPanel>
  );
};
